module.exports = __webpack_public_path__ + "img/logo.b8b45856.png";